import { BaseFieldProps, contextFactory } from '@frontend/design-system';

type EmailHeaderContextState = {
  setSubject: (subject: string) => void;
  subject: string;
  subjectProps?: BaseFieldProps<string>;
  trackingPrefix: string;
};

export const [EmailHeaderContext, useEmailHeader] = contextFactory<EmailHeaderContextState>(
  'useEmailHeader must be used within an EmailHeader'
);
